import * as angular from "angular";
import {IIntervalService, IScope} from "angular";

export interface PollingIntervalRef {
  cancel: () => void;
}

export class PollingIntervalService {

  /* @ngInject */
  constructor(private $interval: IIntervalService) {
  }

  // Starts an interval and cancels it automatically on scope destroy
  // and on ui-router navigation ($stateChangeStart).
  start($scope: IScope, tick: () => void, delay: number): PollingIntervalRef {
    const stop = this.$interval(tick, delay);

    const cancel = () => this.$interval.cancel(stop);

    $scope.$on('$stateChangeStart', cancel);
    $scope.$on('$destroy', cancel);

    return {cancel};
  }
}

angular
  .module('bringoz.admin.commons')
  .service('pollingIntervalService', PollingIntervalService);
